import { useAuth } from "@/contexts/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useToast } from "@/hooks/use-toast";

/**
 * Redirects authenticated users with expired passwords to /reset-password.
 * Place inside BrowserRouter + AuthProvider.
 */
const PasswordExpiryGuard = () => {
  const { user, passwordExpired } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();

  useEffect(() => {
    const exempt = ["/reset-password", "/auth"];
    if (user && passwordExpired && !exempt.includes(location.pathname)) {
      toast({
        title: "Password Expired",
        description: "Your password is over 6 months old. Please update it now.",
        variant: "destructive",
      });
      navigate("/reset-password");
    }
  }, [user, passwordExpired, location.pathname, navigate, toast]);

  return null;
};

export default PasswordExpiryGuard;
